import { useNavigate } from '@tanstack/react-router'
import { useEffect } from 'react'
import { useCurrentUserQuery } from '@/hooks/api'
import { useIsAdmin } from '@/hooks/use-user-type'

export function AdminGuard({ children }: { children: React.ReactNode }) {
  const { isPending } = useCurrentUserQuery()
  const isAdmin = useIsAdmin()
  const navigate = useNavigate()

  useEffect(() => {
    if (!isPending && !isAdmin) {
      navigate({ to: '/', replace: true })
    }
  }, [isPending, isAdmin, navigate])

  if (isPending) return null
  if (!isAdmin) return null

  return <>{children}</>
}
